import React from 'react';
import {Form, Divider} from 'semantic-ui-react'

const HomePr1 = ({autorizacUA, styles, handleChange, handleSubmit, args,
                  handleClickSel1, handleClickSel2, handleClickSel3, handleClickSel4, 
                  handleClickSel5, handleClickSel6, handleClickSel7, handleClickSel8
                  ,handleClickSel9, handleClickSel10, handleClickSel11, handleClickSel12
                }) => { 

//Traer autorizaciones
  const a0105 = autorizacUA.findIndex( autorizac => autorizac === "0105" );
  const a0110 = autorizacUA.findIndex( autorizac => autorizac === "0110" );
  const a0115 = autorizacUA.findIndex( autorizac => autorizac === "0115" );
  const a0120 = autorizacUA.findIndex( autorizac => autorizac === "0120" );
  const a0125 = autorizacUA.findIndex( autorizac => autorizac === "0125" );
  const a0130 = autorizacUA.findIndex( autorizac => autorizac === "0130" );
  const a0135 = autorizacUA.findIndex( autorizac => autorizac === "0135" );
  const a0140 = autorizacUA.findIndex( autorizac => autorizac === "0140" );
  const a0145 = autorizacUA.findIndex( autorizac => autorizac === "0145" );
  const a0150 = autorizacUA.findIndex( autorizac => autorizac === "0150" );

  if(args.numDocum){
    var numDocum = document.getElementById("numDocum");
    if(numDocum){numDocum.value = args.numDocum}
  }

  if(args.descrPlanta){
    var descrPlanta = document.getElementById("descrPlantaB");
    if(descrPlanta){descrPlanta.value = args.descrPlanta}
  }
  if(args.descrSeccion){
    var descrSeccion = document.getElementById("descrSeccionB");
    if(descrSeccion){descrSeccion.value = args.descrSeccion}
  }
  if(args.descrEquipo){
    var descrEquipo = document.getElementById("descrEquipoB");
    if(descrEquipo){descrEquipo.value = args.descrEquipo}
  }
  if(args.descrComponente){
    var descrComponente = document.getElementById("descrComponenteB");
    if(descrComponente){descrComponente.value = args.descrComponente}
  }
  if(args.descrMecanismo){
    var descrMecanismo = document.getElementById("descrMecanismoB");
    if(descrMecanismo){descrMecanismo.value = args.descrMecanismo}
  }
  if(args.estado){
    var estado = document.getElementById("estadoB");
    if(estado){estado.value = args.estado}
  }
  return (
    <div>
      <Form onSubmit={()=>handleSubmit(args)}>
        <div>
          <button className="ui right labeled icon button fluid" type='submit' style={styles.titBuscar}>
            <i className="large search yellow icon"></i>
            Buscar
          </button>

          <div className="ui input fluid">
            <input id='numDocum' name="numDocum" type="number" placeholder="Traer 100 mecanismos" style={styles.dropdown} onChange={handleChange}/>
          </div>
          <div className="ui input fluid">
            <input id='descrPlanta' autoComplete="off" name="descrPlantaB" type="text" placeholder="Planta" style={styles.dropdown} onChange={handleChange}/>
          </div>
          <div className="ui input fluid">
            <input id='descrSeccion' autoComplete="off" name="descrSeccionB" type="text" placeholder="Sección" style={styles.dropdown} onChange={handleChange}/>
          </div>
          <div className="ui input fluid">
            <input id='descrEquipo' autoComplete="off" name="descrEquipoB" type="text" placeholder="Equipo" style={styles.dropdown} onChange={handleChange}/>
          </div>
          <div className="ui input fluid">
            <input id='descrComponente' autoComplete="off" name="descrComponenteB" type="text" placeholder="Componente" style={styles.dropdown} onChange={handleChange}/>
          </div>
          <div className="ui input fluid">
            <input id='descrMecanismo' autoComplete="off" name="descrMecanismoB" type="text" placeholder="Mecanismo" style={styles.dropdown} onChange={handleChange}/>
          </div>
          <div className="ui input fluid">
            <input id='estado' autoComplete="off" name="estadoB" type="text" placeholder="Estado" style={styles.dropdown} onChange={handleChange}/>
          </div>
          <div>
            <Divider inverted />

            <button className="ui right labeled icon button fluid" style={styles.titBuscar}>
              <i className="large list ul yellow icon"></i>
              Opciones
            </button>
          </div>

          <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={(ev)=>handleClickSel12(ev)}>
            <i className="large angle double up red icon"></i>
            Descargar formato de cargue masivo
          </button>
          {a0105!==-1 &&
            <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={(ev)=>handleClickSel1(ev)}>
              <i className="large angle double up red icon"></i>
              Cargar estructura nueva
            </button>
          } 
          {a0105!==-1 &&
            <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={(ev)=>handleClickSel9(ev)}>
              <i className="large angle double down red icon"></i>
              Descargar estructura para edición masiva
            </button>
          }
          {a0105!==-1 &&
            <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={(ev)=>handleClickSel10(ev)}>
              <i className="large edit outline red icon"></i>
              Edición masiva de estructura
            </button>
          }           
          {a0120!==-1 && 
          <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={(ev)=>handleClickSel4(ev)}>
              <i className="large angle double down red icon"></i>
              Descargar archivo para ordenar equipos
            </button>
          }        
          {a0125!==-1 && 
          <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={(ev)=>handleClickSel5(ev)}>
              <i className="large angle double up red icon"></i>
              Cargar archivo para ordenar equipos
            </button>
          }        
          {/* <Divider inverted /> */}
          {a0130!==-1 && 
          <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={(ev)=>handleClickSel6(ev)}>
              <i className="large file pdf outline red icon"></i>
              Asociar documentos a los equipos
          </button>
          }    
          {a0135!==-1 && 
            <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={(ev)=>handleClickSel7(ev)}>
              <i className="large angle double down red icon"></i>
              Descargar archivo para act. acum. de horas y km
            </button>
          }         
          {a0140!==-1 && 
            <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={(ev)=>handleClickSel8(ev)}>
              <i className="large angle double up red icon"></i>
              Cargar archivo para act. acum. de horas y km
            </button>
          }     
          {a0145!==-1 &&
            <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={(ev)=>handleClickSel11(ev)}>
              <i className="large angle double down red icon"></i>
              Descargar PDF de códigos QR
            </button>
          }   
          {a0150!==-1 && 
            <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={(ev)=>handleClickSel2(ev)}>
              <i className="large angle double down red icon"></i>
              Indicadores
            </button>
          }
          {a0150!==-1 &&
            <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={(ev)=>handleClickSel3(ev)}>
              <i className="large angle double down red icon"></i>
              Bitacora
            </button>
          }        
        </div>
      </Form>
    </div>
  )
};

export default HomePr1
